import React, { useState } from "react";
import {
  EditableTextField,
  EditableSelectField,
} from "../../../../../Global_Component/CustomInputComponent";

import { Box, Grid, Typography, Button } from "@mui/material";
import {
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../../Global_Component/GlobalButtonComponent";

const MenuListingClient = () => {
  const [noOfProduct, setNoOfProduct] = useState(["Product1", "Product2"]);

  function addMoreProduct() {
    setNoOfProduct([...noOfProduct, `Product${noOfProduct.length + 1}`]);
  }

  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "auto",
        padding: "10px",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        backgroundColor: "#fff",
        height: "auto",
      }}
    >
      <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "bold", color: "#333" }}
      >
        Star hospital and Service list
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          width: "100%",
          height: "auto",
        }}
      >
        <Grid
          container
          spacing={0}
          sx={{ m: 0, p: 0, height: "100%", overflowY: "auto" }}
        >
          <Grid
            container
            sx={{
              borderBottom: "1px solid #ccc", // Optional for row distinction
              p: 1,
              m: 0,
            }}
          >
            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableTextField
                name="name"
                label="Concierge Services"
                value="Asistance with trael arrangements, restaurant reservation and other guest request"
                isEdit={false}
              />
            </Grid>

            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableSelectField
                name="usage"
                label="Status"
                value="Provided by hotel adminstration"
                options={[
                  {
                    label: "Provided by hotel adminstration",
                    value: "Provided by hotel adminstration",
                  },
                ]}
                isEdit={true}
              />
            </Grid>

            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableTextField
                name="price"
                label="Manager/Provider/POC Name"
                value="Mohammad akhlaq"
                isEdit={true}
              />
            </Grid>

            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableTextField
                name="usage"
                label="Manager /Provider/POC Number"
                value="8956369962"
                isEdit={true}
              />
            </Grid>
          </Grid>
        </Grid>


        <Grid
          container
          spacing={0}
          sx={{ m: 0, p: 0, height: "100%", overflowY: "auto" }}
        >
          <Grid
            container
            sx={{
              borderBottom: "1px solid #ccc", // Optional for row distinction
              p: 1,
              m: 0,
            }}
          >
            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableTextField
                name="name"
                label="From Desk Services"
                value="Effcient checkin and checkout servvides as well as information about thje hotel"
                isEdit={false}
              />
            </Grid>

            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableSelectField
                name="usage"
                label="Status"
                value="Provided by hotel adminstration"
                options={[
                  {
                    label: "Provided by hotel adminstration",
                    value: "Provided by hotel adminstration",
                  },
                ]}
                isEdit={true}
              />
            </Grid>

            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableTextField
                name="price"
                label="Manager/Provider/POC Name"
                value="Mohammad akhlaq"
                isEdit={true}
              />
            </Grid>

            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableTextField
                name="usage"
                label="Manager /Provider/POC Number"
                value="8956369962"
                isEdit={true}
              />
            </Grid>
          </Grid>
        </Grid>




        <Grid
          container
          spacing={0}
          sx={{ m: 0, p: 0, height: "100%", overflowY: "auto" }}
        >
          <Grid
            container
            sx={{
              borderBottom: "1px solid #ccc", // Optional for row distinction
              p: 1,
              m: 0,
            }}
          >
            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableTextField
                name="name"
                label="Room Services"
                value="24/7 room services offering a diverse menu for in room dinning"
                isEdit={false}
              />
            </Grid>

            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableSelectField
                name="usage"
                label="Status"
                value="select"
                options={[
                  {
                    label: "select",
                    value: "select",
                  },
                ]}
                isEdit={true}
              />
            </Grid>

            

           
          </Grid>
        </Grid>




        <Grid
          container
          spacing={0}
          sx={{ m: 0, p: 0, height: "100%", overflowY: "auto" }}
        >
          <Grid
            container
            sx={{
              borderBottom: "1px solid #ccc", // Optional for row distinction
              p: 1,
              m: 0,
            }}
          >
            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableTextField
                name="name"
                label="Luxury Accomodation"
                value="Well - appointed room and suites with high-quality furnishing bedding and ammeniteis"
                isEdit={false}
              />
            </Grid>

            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableSelectField
                name="usage"
                label="Status"
                value="select status"
                options={[
                  {
                    label: "select status",
                    value: "select status",
                  },
                ]}
                isEdit={true}
              />
            </Grid>

            

            
          </Grid>
        </Grid>



        <Grid
          container
          spacing={0}
          sx={{ m: 0, p: 0, height: "100%", overflowY: "auto" }}
        >
          <Grid
            container
            sx={{
              borderBottom: "1px solid #ccc", // Optional for row distinction
              p: 1,
              m: 0,
            }}
          >
            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableTextField
                name="name"
                label="Concierge Service"
                value="Asistnace with travel arrangements,restaurant reservation and other"
                isEdit={false}
              />
            </Grid>

            <Grid item md={6} sx={{ p: 0.5, m: 0 }}>
              <EditableSelectField
                name="usage"
                label="Status"
                value="select status"
                options={[
                  {
                    label: "select status",
                    value: "select status",
                  },
                ]}
                isEdit={true}
              />
            </Grid>

            

            
          </Grid>
        </Grid>






      </Box>

      <Grid
        xs={12}
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-stat",
          gap: 1,
          borderTop: "1px solid gray",
        }}
      >
        <Grid md={"10"}>
          <Button onClick={addMoreProduct}>Add more Product</Button>
        </Grid>
        <Grid
          md={"12"}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <CustomSecondaryButton label={"Back"} sx={{ margin: 2 }} />
          <CustomSuccessButton label={"Next"} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MenuListingClient;
